module.exports = __webpack_public_path__ + "UX32.png?a972e1e4474a33390354aec0f5248abf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX32.png
// module id = 83
// module chunks = 0